import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedUiDowntimeNotificationModule } from '@common/downtime-notification';
import { UserNotificationService } from '@common/util/user-notification.service';
import { AppSwitcherModule } from './app-switcher/app-switcher.module';
import { SidebarComponent } from './sidebar.component';
import { NavigationToolbarModule } from './toolbar/toolbar.module';

@NgModule({
  declarations: [SidebarComponent],
  imports: [
    AppSwitcherModule,
    BrowserModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSidenavModule,
    MatTooltipModule,
    NavigationToolbarModule,
    MatDialogModule,
    SharedUiDowntimeNotificationModule,
  ],
  exports: [SidebarComponent],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'right' } },
    UserNotificationService,
  ],
})
export class SidebarModule {}
